import { commerceFacetOrderReducer as facetOrder } from '../facets/facet-order/commerce-facet-order-slice.js';
import { commerceFacetSetReducer as commerceFacetSet } from '../facets/facet-set/facet-set-slice.js';
import { paginationReducer as commercePagination } from '../pagination/pagination-slice.js';
import { sortReducer as commerceSort } from '../sort/sort-slice.js';
import { restoreProductListingParameters, } from './product-listing-parameters-actions.js';
/**
 * Loads the commerce facet order, facet set, pagination, and sort reducers and returns the available product listing parameters action creators.
 *
 * @param engine - The headless commerce engine.
 * @returns An object holding the product listing parameters action creators.
 *
 * @group Actions
 * @category ProductListingParameters
 */
export function loadProductListingParametersActions(engine) {
    engine.addReducers({
        facetOrder,
        commerceFacetSet,
        commercePagination,
        commerceSort,
    });
    return {
        restoreProductListingParameters,
    };
}
